import { ref } from 'vue'

const isOpen = ref(false)

/** Account closure choice modal, deactivate (freeze) vs permanent delete. */
export function useCloseAccountModal() {
  const openCloseAccountModal = () => {
    isOpen.value = true
  }

  const closeCloseAccountModal = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    openCloseAccountModal,
    closeCloseAccountModal,
  }
}
